import { render, staticRenderFns } from "./ManageCalibrationPatternerMetricsRanges.vue?vue&type=template&id=8e70f2a8&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageCalibrationPatternerMetricsRanges.vue?vue&type=style&index=0&id=8e70f2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e70f2a8",
  null
  
)

export default component.exports